import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { getRouteContentCommitKey, useLoaderContext } from './LoaderContext';

export function RouteContentCommitSignal() {
  const { markRouteContentCommitted } = useLoaderContext();
  const location = useLocation();
  const routeContentCommitKey = getRouteContentCommitKey(location);

  useEffect(() => {
    markRouteContentCommitted(routeContentCommitKey);
  }, [markRouteContentCommitted, routeContentCommitKey]);

  return null;
}
